import { Exclude, Expose } from 'class-transformer';
import { ICountry } from '../interfaces';
import { BaseModel } from './base.model';

@Exclude()
export class CountryModel extends BaseModel implements ICountry {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  alpha2!: string;

  @Expose()
  alpha3!: string;

  @Expose()
  numeric!: string;

  @Expose()
  isSactioned!: boolean;

  @Expose()
  code!: string;

  @Expose()
  status!: string;

  @Expose()
  isDefault?: boolean;

  @Expose()
  defaultCurrencyId?: number;

  @Expose()
  createdAt?: string;

  @Expose()
  updatedAt?: string;
}

@Exclude()
export class ProvinceModel extends BaseModel {
  @Expose()
  id!: number;

  @Expose()
  countryId!: number;

  @Expose()
  name!: string;
}

@Exclude()
export class CityModel extends BaseModel {
  @Expose()
  id!: number;

  @Expose()
  countryId!: number;

  @Expose()
  provinceId?: number;

  @Expose()
  name!: string;
}

@Exclude()
export class NationalityModel extends BaseModel {
  @Expose() id!: number;
  @Expose() businessUnitId!: number;
  @Expose() countryId!: number;
  @Expose() sibs!: string;
  @Expose() nationality!: string;
  @Expose() telCountryCode!: string;
}
